import type { TeamDTO } from '@/global/GlobalType';

const storageKey = (userId: string): string => `sparrow_team_recent_${userId}`;

export const recordTeamVisit = (userId: string, teamId: string): void => {
  if (!userId || !teamId) {
    return;
  }
  const key = storageKey(userId);
  let list: string[] = [];
  try {
    list = JSON.parse(localStorage.getItem(key) || '[]') as string[];
  } catch {
    list = [];
  }
  const next = [teamId, ...list.filter(id => id !== teamId)].slice(0, 50);
  localStorage.setItem(key, JSON.stringify(next));
};

const compareTeamName = (a: TeamDTO, b: TeamDTO): number =>
  (a.teamName || '').localeCompare(b.teamName || '', 'zh-CN');

export const sortTeamListForUser = (teams: TeamDTO[], userId: string): TeamDTO[] => {
  if (!teams.length) {
    return teams;
  }
  let recent: string[] = [];
  try {
    recent = JSON.parse(localStorage.getItem(storageKey(userId)) || '[]') as string[];
  } catch {
    recent = [];
  }
  const rank = new Map(recent.map((id, index) => [id, index]));
  return [...teams].sort((a, b) => {
    const ra = rank.has(a.id) ? rank.get(a.id)! : Number.MAX_SAFE_INTEGER;
    const rb = rank.has(b.id) ? rank.get(b.id)! : Number.MAX_SAFE_INTEGER;
    if (ra !== rb) {
      return ra - rb;
    }
    return compareTeamName(a, b);
  });
};

export const pickDefaultTeamId = (teams: TeamDTO[], userId: string): string => {
  const sorted = sortTeamListForUser(teams, userId);
  return sorted[0]?.id || teams[0]?.id || '';
};
